import { render, staticRenderFns } from "./ListUserActions.vue?vue&type=template&id=56674f07&"
import script from "./ListUserActions.vue?vue&type=script&lang=js&"
export * from "./ListUserActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports